import { EventEmitter } from 'events';
export class Globals {
}
Globals.sessionExpired = new EventEmitter();
Globals.sessionWarning = new EventEmitter();
//# sourceMappingURL=globals.js.map
